<div class="loading-container" [ngClass]="{'loading-overlay-container': overlay}">
  <h2 class="text-center">{{loadingText}}</h2>
</div>
